module.exports = __webpack_public_path__ + "img/weddingRingsSoleil-emotion-03@2x.9348e56.webp";